/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{f as e}from"../../../../../../chunks/vec4f64.js";import{glsl as o}from"../../shaderModules/interfaces.js";import{Texture2DPassUniform as t}from"../../shaderModules/Texture2DPassUniform.js";const d=e(1,1,0,1),r=e(1,0,1,1);function a(e){e.fragment.uniforms.add(new t("depthTexture",((e,o)=>o.mainDepth))),e.fragment.constants.add("occludedHighlightFlag","vec4",d).add("unoccludedHighlightFlag","vec4",r),e.fragment.code.add(o`void outputHighlight() {
float sceneDepth = float(texelFetch(depthTexture, ivec2(gl_FragCoord.xy), 0).x);
if (gl_FragCoord.z > sceneDepth + 5e-7) {
fragColor = occludedHighlightFlag;
} else {
fragColor = unoccludedHighlightFlag;
}
}`)}export{a as OutputHighlight,d as occludedHighlightFlag,r as unoccludedHighlightFlag};
